import React from "react";
import "./Footer.scss";

export function Footer() {
  return (
    <footer>
      <div className="text-center">
        <span className="fw-bold">Copyright 2025</span>
        <br />
        Website created by <span className="fst-italic">Yuki</span>
      </div>
    </footer>
  );
}
